import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CustomProduct } from '@product/const';
import { SdBottomSheetService, SdModalService, SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { SdBottomSheetOptions } from '@shared/v2';
import { take } from 'rxjs';
import { ProductTransitRequestComponent } from '../../../product-transit-request';

@Component({
  selector: 'sd-transit-order',
  imports: [SdvorButtonComponent],
  templateUrl: './transit-order.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransitOrderComponent {
  isTabletMdUp$ = this.deviceService.isTabletMdUp$;

  @Input() product: CustomProduct;

  constructor(
    private sdModalService: SdModalService,
    private deviceService: DeviceService,
    private bottomSheetService: SdBottomSheetService,
  ) {}

  onTransitOrder(): void {
    this.isTabletMdUp$.pipe(take(1)).subscribe((isTabletMdUp) => {
      if (isTabletMdUp) {
        const modal = this.sdModalService.open(ProductTransitRequestComponent, {
          ignoreOutsideClick: true,
          maxWidth: '500px',
        });
        modal.contentRef.setInput('product', this.product);
      } else {
        const data = {
          product: this.product,
        };
        const options: SdBottomSheetOptions<{
          product: CustomProduct;
        }> = {
          ignoreOutsideClick: false,
          blockOverlay: true,
          hasCloseButton: false,
          breakpoints: [80],
          init: {
            type: 'percent',
            value: 80,
          },
          background: 'white',
          data: data,
        };
        this.bottomSheetService.open(ProductTransitRequestComponent, options);
      }
    });
  }
}
